/**
 * Compose the CSS `filter` chain applied to the main review image (AKL-681).
 *
 * Returns `undefined` when neither adjustment is active so the DOM never
 * carries an empty `filter:` attribute (which would still trigger a paint pass
 * on some browsers).
 *
 * @param brightness a multiplier in the 0.5–2.0 range; `1` means unchanged.
 * @param sharpen when true, appends the inline SVG sharpen filter reference.
 * @returns a space-joined CSS `filter` string, or `undefined` for a no-op.
 */
export const SHARPEN_FILTER_ID = "akili-sharpen";

export const buildImageFilter = ({
  brightness,
  sharpen,
}: {
  brightness: number;
  sharpen: boolean;
}): string | undefined => {
  const parts: string[] = [];
  if (brightness !== 1) parts.push(`brightness(${brightness})`);
  if (sharpen) parts.push(`url(#${SHARPEN_FILTER_ID})`);
  return parts.length > 0 ? parts.join(" ") : undefined;
};
